import { render } from "./user-list.vue?vue&type=template&id=7e8bf596"
import script from "./user-list.vue?vue&type=script&lang=ts"
export * from "./user-list.vue?vue&type=script&lang=ts"

import "./user-list.vue?vue&type=style&index=0&id=7e8bf596&lang=less"
script.render = render

export default script